import { JSONValue } from '../types';
import { getApiBaseUrl } from './apiBase';

export async function postRequest(url: string, body: JSONValue) {
  const apiBase = getApiBaseUrl();
  const result = await fetch(`${apiBase}${url}`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
    body: JSON.stringify(body),
  });
  return await result.json();
}
